import { ReactElement } from 'react';

import Loading from 'components/Icons/Loading';

import { SearchParamsContextProvider } from '../../contexts/SearchParamsContext';
import {
  FilterableQueryOptionsType,
  FilterableQueryRefetchType,
  FilterableQueryResultType,
  FiltersInterface,
} from '../../types';
import { FetchData } from './FetchData';
import * as Styled from './TablePage.styles';

export interface TablePageProps<T> {
  defaultParams?: FiltersInterface;
  filterComponent?: ReactElement;
  tableComponent: (data: FilterableQueryResultType<T>) => ReactElement;
  filtersComponent?: (data: FilterableQueryRefetchType<T>) => ReactElement;
  tableProps?: Record<string, any>;
  filtersProps?: Record<string, any>;
  request: (
    filters: FiltersInterface,
    options?: FilterableQueryOptionsType<T>
  ) => FilterableQueryResultType<T>;
}

export function TablePage<T>({
  defaultParams,
  tableComponent: TableComponent,
  filtersComponent: FiltersComponent,
  tableProps = {},
  filtersProps = {},
  request,
}: TablePageProps<T>) {
  return (
    <SearchParamsContextProvider defaultParams={defaultParams}>
      <FetchData<T> request={request}>
        {(data) => (
          <>
            {FiltersComponent && (
              <FiltersComponent
                refetch={data.refetch}
                isFetching={data.isFetching}
                {...filtersProps}
              />
            )}
            {data.isFetching ? (
              <Loading isFullScreen />
            ) : (
              <Styled.TableContainer>
                <TableComponent {...data} {...tableProps} />
              </Styled.TableContainer>
            )}
          </>
        )}
      </FetchData>
    </SearchParamsContextProvider>
  );
}
